// 🔧 index.js
// ✅ Purpose: Entry point for the Ticket Demo Engine
// ✅ Features:
// - Exposes runTicketEngine()
// - Runs Ticket Builder when Tickets is selected
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildTickets } from "./ticket_builder";

export const runTicketEngine = async ({ demoContext } = {}) => {
  console.log("🎫 Ticket Engine started.");

  const result = await buildTickets({ demoContext });

  console.log("✅ Ticket Engine completed.", { result });

  return result;
};